import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { OperatorService } from 'src/app/core/services/operator/operator.service';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { GameId } from 'src/app/model/game/game-id';

interface TabOption {
  label: string;
  id: string;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  @Input({ required: true }) gameName!: string;
  @Input({ required: true }) gameId!: GameId;
  @Input() tabs?: TabOption[];
  @Input() balance?: string;

  @Output() closeClicked = new EventEmitter<void>();
  @Output() themeClicked = new EventEmitter<void>();
  @Output() tabSelected = new EventEmitter<string>();

  OperatorService = OperatorService;
  operatorService = inject(OperatorService);
  themeService = inject(ThemeService);

  currencyIcon = this.themeService.currencyIcon();

  get balancePillStyles(): [string, string][] {
    const key = 'pill-balance';
    return [
      ['background', key],
      ['border-radius', key],
      ['text-color', `${key}-amount`],
      ['type', `${key}-amount`],
      ['border', key],
    ];
  }

  onCloseClicked() {
    this.closeClicked.emit();
  }

  onThemeClicked() {
    this.themeClicked.emit();
  }

  onTabSelected(event: string) {
    this.tabSelected.emit(event);
  }
}
